import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,

	Box,
	Grid,
	Button,
	TextField,
	Typography
} from "@mui/material";
import {
	withStyles,
	makeStyles
} from "@mui/styles";
import {
	Close as CloseIcon
} from "@mui/icons-material";

class DialogCarAcceptance extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			files: [],
			message: "",
			isOpen: false,
			onSubmit: null
		}
	}

	open = ({ onSubmit }) => {
		this.setState({
			isOpen: true,
			onSubmit
		})
	}
	close = () => {
		this.setState({
			files: [],
			message: "",
			isOpen: false,
			onSubmit: null
		})
	}
	submit = () => {
		const { files, message } = this.state;

		const formData = new FormData();
		formData.append("message", message)
		files.map((file) => {
			formData.append("files[]", file);
		});

		this.state.onSubmit(formData);
	}

	changeFiles = ({ target }) => {
		const trFiles = [...(target.files || [])];
		target.value = null;
		this.setState({
			files: [...this.state.files, ...trFiles]
		})
	}
	removeFile = (index) => {
		let files = [...this.state.files];
		files.splice(index, 1);
		this.setState({ files });
	}

	changeMessage = ({ target }) => {
		this.setState({
			message: target?.value || ''
		});
	}

	render () {
		const {
			classes
		} = this.props;
		const {
			files,
			message,
			isOpen
		} = this.state;

		return (
			<Dialog
				fullWidth
				open={isOpen}
				maxWidth="sm"
				classes={{root: classes.dialog}}
			>
				<DialogTitle>
					<Typography variant="h3">Приемка авто</Typography>
				</DialogTitle>
				<DialogContent>
					<Box pt={1}/>
					<Box className={classes.section}>
						<Typography className={classes.sectionTitle}>Фото / видео фиксация</Typography>
						<Grid container spacing={1}>
							{(files || []).map((file, index) => (
								<Grid item xs={4}>
									<FileItemCard
										key={`FileItemCard-${ file.lastModified }`}
										item={file}
										onRemove={this.removeFile.bind(this, index)}
									/>
								</Grid>
							))}
							<Grid item xs={12}>
								<label>
									<input
										hidden
										multiple
										type="file"
										accept="image/*"
										onChange={this.changeFiles}
									/>
									<Button
										fullWidth
										component="span"
										variant="outlined"
									>Выбрать/сделать фото</Button>
								</label>
							</Grid>
						</Grid>
					</Box>
					<Box mt={2}/>
					<Box className={classes.section}>
						<Typography className={classes.sectionTitle}>Описание</Typography>
						<TextField
							rows={4}
							fullWidth
							multiline
							size="small"
							value={message}
							onChange={this.changeMessage}
							placeholder="Опишите детали по приемке, видимые повреждения и тд"
						/>
					</Box>
				</DialogContent>
				<DialogActions>
					<Box px={2}>
						<Grid container spacing={1} justifyContent="flex-end">
							<Grid item>
								<Button
									variant="outlined"
									onClick={this.close}
								>Отменить</Button>
							</Grid>
							<Grid item>
								<Button
									variant="contained"
									disabled={files.length <= 0 && message.length <= 0}
									onClick={this.submit}
								>Подтвердить</Button>
							</Grid>
						</Grid>
					</Box>
				</DialogActions>
			</Dialog>
		)
	}
}
const FileItemCard = ({ item, disabledEdit, onRemove }) => {
	const classes = useStyles();
	const [objectUrl] = React.useState(() => {
		return URL.createObjectURL(item);
	})

	return (
		<Box
			className={classes.fileItemCard}
		>
			{Boolean(String(item?.type || '').includes('image/')) && (
				<img src={objectUrl} className={classes.fileItemCardIframe}/>
			)}
			{Boolean(String(item?.type || '').includes('video/')) && (
				<iframe src={objectUrl} className={classes.fileItemCardIframe}/>
			)}
			{Boolean(!disabledEdit) && (
				<div className={classes.fileItemCardClose} onClick={onRemove}>
					<CloseIcon sx={{color: "#FF3F3F"}}/>
				</div>
			)}
		</Box>
	)
}

const useStyles = makeStyles(() => ({
	fileItemCard: {
		width: "100%",
		display: "flex",
		overflow: "hidden",
		borderRadius: "8px",
		position: "relative",
		border: "1px solid #0000002e",
		"&:after": {
			content: "''",
			float: "left",
			paddingTop: "100%"
		}
	},
	fileItemCardIframe: {
		position: "absolute",
		top: "0", left: "0",
		width: "100%",
		height: "100%",
		objectFit: "contain",

		"& img": {
			maxWidth: "100%",
			maxHeight: "100%"
		}
	},
	fileItemCardClose: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer",
		zIndex: 4,
		position: "absolute",
		top: 0, right: 0,
		width: 32, height: 32,
	}
}));

const styles = {
	dialog: {
		"& .MuiDialogTitle-root": {
			background: "#FF3F3F",
		},
		"& .MuiDialogTitle-root .MuiTypography-h3": {
			color: "white",
			textAlign: "left",
		},
	},

	section: {},
	sectionTitle: {
		marginBottom: 8,
		fontSize: 18,
		lineHeight: 1.2,
		fontWeight: "600",
	},
};
DialogCarAcceptance = withStyles(styles)(DialogCarAcceptance);

export default DialogCarAcceptance
export {
	FileItemCard
}
